import { Route } from 'react-router-dom';
import AnalyticsPage from './pages/AnalyticsPage';
import StaffReportPage from './pages/StaffReportPage';
import DailyCutPage from './pages/DailyCutPage';

export const AnalyticsRoutes = [
  <Route key="analytics" path="/dashboard/analytics" element={<AnalyticsPage />} />,
  <Route key="staff-report" path="/dashboard/staff-report" element={<StaffReportPage />} />,
  <Route key="daily-cut" path="/dashboard/daily-cut" element={<DailyCutPage />} />
];